if (window.Sentry && process.env.SENTRY_ENABLE) {
  try {
    window.Sentry.init({
      dsn: process.env.SENTRY_DSN,
      integrations: [new window.Sentry.BrowserTracing()],
      environment: process.env.ENVIRONMENT,
      sampleRate: 0.8,
      tracesSampleRate: 0.8,
      ignoreErrors: [/yaCounter/i],
    });

    if (window.atiUser && window.atiUser.is_user) {
      window.Sentry.setUser({
        id: window.atiUser.profile.ati_code,
        username: window.atiUser.profile.firm_name,
        contact: {
          id: window.atiUser.profile.contact.id,
          name: window.atiUser.profile.contact.name,
        },
      });
    }
  } catch (e) {
    console.error(e);
  }
} else {
  window.Sentry = {
    captureMessage() {},
    captureException() {},
    setContext() {},
    setUser() {},
    getCurrentHub() {},
    init() {},
    setTag() {},
  };
}
